import Service from '../Service';
import AssignmentBanner from '../AssignmentBanner';
import NoContent from '../common/NoContent';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import './Services.scss';

const Services = ({ services, songs, editServiceId, onViewService, onEditService, onDeleteService, loading, hide }) => {
  const { t } = useTranslation();
  const servicesClasses = classNames('services', { hide: hide });

  const renderServices = () => {
    if (services.length !== 0)
      return (
        <ul className="services-list">
          {services.map((service) => (
            <Service
              key={service._id}
              service={service}
              songs={songs}
              onViewService={onViewService}
              onDelete={onDeleteService}
              onEdit={onEditService}
              editId={editServiceId}
            />
          ))}
        </ul>
      );
    else return <NoContent loading={loading} message={t('services.noUpcoming')} />;
  };

  return (
    <div className={servicesClasses}>
      <AssignmentBanner services={services} songs={songs} />
      {renderServices()}
    </div>
  );
};

export default Services;
